import React from 'react';

export const IMPORT_STEPS = [
  { key: 'folder', label: 'Folder & survey' },
  { key: 'classes', label: 'Target classes' },
  { key: 'audience', label: 'Choose audience' },
];

const ImportSurveySteps = ({ reachedIndex, currentIndex, onStepClick }) => {
  return (
    <div className="import-steps">
      {IMPORT_STEPS.map((step, index) => (
        <React.Fragment key={step.key}>
          <div
            className={`import-step ${index <= reachedIndex ? 'reached' : ''} ${index === currentIndex ? 'current' : ''}`}
            onClick={() => index < reachedIndex && onStepClick(index)}
          >
            <span className="import-step-circle">{index + 1}</span>
            <span className="import-step-label">{step.label}</span>
          </div>
          {index < IMPORT_STEPS.length - 1 && <span className="import-step-connector"></span>}
        </React.Fragment>
      ))}
    </div>
  );
};

export default ImportSurveySteps;
